<audio #audioEl autoplay hidden aria-hidden="true"></audio>
<div class="flex flex-col h-screen">
  <app-mib-header class="shrink-0 w-full"></app-mib-header>
  <main
    class="p-6 flex-1 flex flex-col gap-6"
    aria-label="AI assistant responses"
    aria-live="polite"
    aria-relevant="additions"
  >
    @if (isDisconnected()) {
      <div class="flex-1 flex items-center justify-center">
        <p class="text-muted-foreground text-center" role="status">Session terminated</p>
      </div>
    } @else if (waitingMessage(); as message) {
      <mib-spinner overlay size="large">
        <p class="text-muted-foreground text-center" role="status">{{ message }}</p>
      </mib-spinner>
    } @else {
      @if (agentAnswer(); as message) {
        <app-chat-message [message]="message" [sentByUser]="false" [showTime]="false" bigText />
      }

      @if (playingAudio()) {
        <div class="w-full h-50">
          <ng-lottie [options]="voiceAnimation" width="100%" height="100%" />
        </div>
      }
    }
  </main>
</div>
